<template>
  <v-menu open-on-hover>
    <template v-slot:activator="{ on: menu, attrs }">
      <div v-bind="attrs" v-on="{ ...menu }">
        <template v-if="coberturas_unicas_computed.length">
          <v-chip
            v-for="(tempo_cobertura, key) in coberturas_unicas_computed"
            :key="key"
            class="ma-1"
            small
          >
            {{ tempo_cobertura }} dias
          </v-chip>
        </template>

        <span v-else class="text-gray-800">Não cadastrado</span>
      </div>
    </template>

    <div v-if="coberturas_unicas_computed.length" class="bg-white pt-5 pb-3 px-5">
      <p class="mb-1 font-16 font-weight-medium">Coberturas por filiais</p>

      <div v-for="(cobertura, key) in coberturas_unicas_computed" :key="key">
        <span>{{ cobertura }} dias</span>

        <div class="font-14 mb-2">
          <ul v-for="(item, key) in props.itens.filter(i => i.tempo_cobertura === cobertura)" :key="key">
            <div class="d-flex justify-space-between align-center">
              <li>{{ item.filial }} - {{ item.descricao }}</li>

              <v-btn
                class="ml-2"
                style="width: 15px; height: auto"
                icon
                @click="excluirItem(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </v-menu>
</template>

<script setup>
import { computed } from "vue";
import { logout } from "@/helpers";
import api from "@/api/api";

const props = defineProps(['itens', 'entidade', 'id_entidade']);
const emit = defineEmits(['update:coberturas-filial']);

const coberturas_unicas_computed = computed(() => {
  return Array.from((new Set((props.itens || []).map(i => i.tempo_cobertura))));
});

function excluirItem(cobertura) {
  const url = 'compras/cobertura-por-excecao/' + props.entidade + 's/filiais/' + 0;
  const params = {
    data: {
      idfilial: cobertura.filial,
      [`id${props.entidade}`]: String(props.id_entidade)
    }
  };

  api.delete(url, params)
    .then(response => {
      const { token } = response.data;
      localStorage.token = token;

      emit('update:coberturas-filial', true);
    })
    .catch(logout);
}
</script>
